// extracted by mini-css-extract-plugin
module.exports = {"InfoImageContainer":"DocumentInfoImage_InfoImageContainer__2xv8r"};